/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { callabo__models__audit__Device } from './callabo__models__audit__Device';
import type { Geo } from './Geo';

/**
 * 워크스페이스 초대 관련 audit log
 */
export type AuditLogWorkspaceInvite = {
  ts: string;
  workspace_id: number;
  user_id?: number | null;
  system_actor?: boolean | null;
  ip?: string | null;
  device: callabo__models__audit__Device;
  geo?: Geo | null;
  user_agent?: string | null;
  action: AuditLogWorkspaceInvite.action;
  invitee_email: string;
  inviter_user_id?: number | null;
  base_role?: string | null;
  role_ids?: Array<number> | null;
  already_user?: boolean | null;
  invitee_user_id?: number | null;
  is_signup?: boolean | null;
  status?: string | null;
  /**
   * 하위 클래스에서 구현해야 하는 action type
   */
  readonly action_type: string;
};

export namespace AuditLogWorkspaceInvite {
  export enum action {
    WORKSPACE_INVITE_SEND = 'workspace.invite.send',
    WORKSPACE_INVITE_ACCEPT = 'workspace.invite.accept',
  }
}
